import { meta } from '@/helpers/constants/router';
// lazy load components
// https://router.vuejs.org/guide/advanced/lazy-loading.html
const Settings = () => import('@/views/apps/Settings.vue');
const MembersIndex = () => import('@/components/settings/members/Index.vue');
const MembersNew = () => import('@/components/settings/members/Form.vue');
const Viber = () => import('@/components/v2/ViberSubscriptionForm.vue');
const Instagram = () => import('@/components/v2/InstagramSubscriptionForm.vue');
const MiniProgram = () => import('@/components/v2/MiniProgramSubscriptionForm.vue');
const Subscription = () => import('@/components/v2/Subscription.vue');
const SettingsPageSubscription = () => import('@/views/apps/SettingsPageSubscription.vue');
const Wrapper = () => import('@/views/Wrapper.vue');
const PageSettings = () => import('@/views/apps/MiniAppSettings.vue');
const ShopifySettings = () => import('@/components/v2/diy/ShopifySettings.vue');
const DistributorSettings = () => import('@/views/v2/distributor/DistributorSettings.vue');
const ChatbotSettings = () => import('@/views/v3/chatbot_settings/ChatbotSettingsManager.vue');
/**
 * App Settings Routes
 * path: Route Path
 * meta: For checking internal validations such as `authorization`.
 *  also used to manipulate breadcrumbs link using `title` meta.
 * redirect: Mainly Used In Breadcrumb to identify parent menu for nested routes
 * using $route.matched.
 * children: Nested Routes.
 */
const isB2c = (key) => {
    return /ecommerce-b2c|shopify/.test(key.toLowerCase());
};
const beforeEnter = (to, from, next) => {
    to.meta.title = isB2c(to.params.key) ? 'General Store Manager' : 'Settings';
    to.meta.subtitle = isB2c(to.params.key) ? 'Manage other store features and settings here.' : '';
    next();
};
export default [
    {
        path: 'settings',
        component: Settings,
        redirect: 'mini-app-settings',
        meta: { ...meta, title: 'Settings' },
        children: [
            {
                path: 'page-subscription',
                name: 'page-subscription',
                component: Subscription,
                meta: { title: 'Sales Channel Settings' },
                redirect: { name: 'facebook-page-subscription' },
                children: [
                    {
                        path: '/',
                        name: 'facebook-page-subscription',
                        meta: {
                            title: 'Sales Channel Settings',
                            subtitle: 'Manage your various sales channel settings here.',
                            childTitle: 'Facebook Messenger In-App Store',
                        },
                        component: SettingsPageSubscription,
                    },
                    {
                        path: 'miniprogram-subscription',
                        name: 'miniprogram-subscription',
                        meta: {
                            title: 'Sales Channel Settings',
                            subtitle: 'Manage your various sales channel settings here.',
                            childTitle: 'GCash (GLife) Mini Program Onboarding Form',
                        },
                        component: MiniProgram,
                    },
                    {
                        path: 'viber-subscription',
                        name: 'viber-subscription',
                        meta: {
                            title: 'Sales Channel Settings',
                            subtitle: 'Manage your various sales channel settings here.',
                            childTitle: 'Viber Mini App'
                        },
                        component: Viber,
                    },
                    {
                        path: 'instagram-subscription',
                        name: 'instagram-subscription',
                        meta: {
                            title: 'Sales Channel Settings',
                            subtitle: 'Manage your various sales channel settings here.',
                            childTitle: 'Instagram Mini App'
                        },
                        component: Instagram,
                    },
                ],
            },
            {
                path: 'mini-app-settings',
                name: 'mini-app-settings',
                beforeEnter,
                meta: {
                    title: 'General Store Manager',
                    subtitle: 'Manage other store features and settings here.',
                    childTitle: 'In-App Store Settings',
                },
                component: PageSettings,
            },
            {
                path: 'shopify-settings',
                name: 'shopify-settings',
                beforeEnter,
                meta: {
                    title: 'General Store Manager',
                    subtitle: 'Manage other store features and settings here.',
                    childTitle: 'Shopify Settings',
                },
                component: ShopifySettings,
            },
            {
                path: 'distributor-settings',
                name: 'distributor-settings',
                meta: {
                    title: 'In-App Store Settings',
                    subtitle: 'Manage administrator and page subscription',
                },
                component: DistributorSettings,
            },
            {
                path: 'maintenance',
                name: 'app-maintenance',
                beforeEnter,
                meta: {
                    childTitle: 'Maintenance',
                },
                component: () => import('@/views/apps/Maintenance.vue'),
            },
            {
                path: 'members',
                component: Wrapper,
                redirect: 'members',
                meta: { childTitle: 'Members' },
                children: [
                    {
                        path: '/',
                        name: 'members',
                        component: MembersIndex,
                        beforeEnter,
                        meta: { ...meta, title: 'Members', childTitle: 'Members' },
                    },
                    {
                        path: 'create',
                        name: 'members-create',
                        component: MembersNew,
                        meta: { title: 'Create Member' },
                    },
                ],
            },
            {
                path: 'ai-settings',
                component: Wrapper,
                redirect: 'ai-settings',
                meta: { childTitle: 'Chatbot Settings' },
                children: [
                    {
                        path: '/',
                        name: 'ai-settings',
                        component: ChatbotSettings,
                        beforeEnter,
                        meta: { ...meta, title: 'Chatbot Settings', childTitle: 'Chatbot Settings' },
                    },
                ],
            },
        ],
    },
];
